import CompanyCollections from './CompanyCollections';

export default CompanyCollections;
